import { Button } from '@creditornot/cb-button';
import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import { ModalFooter } from '@creditornot/cbt-modal';
import styled from 'styled-components';

import { WoltModal } from 'common/components';

export const Root = styled(WoltModal)`
  min-width: 320px;
  max-width: 640px;
  background-color: ${cbSemanticCssVars.surfaceMain};
  color: ${cbSemanticCssVars.textPrimary};
  padding: 0;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  overflow-y: visible;
`;

export const Content = styled.div``;

export const Footer = styled(ModalFooter)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const CancelButton = styled(Button).attrs({ variant: 'secondary', size: 'small' })`
  margin-inline-end: 16px;
`;
export const SubmitButton = styled(Button).attrs({ variant: 'primary', size: 'small' })``;
